import { IdName } from '../../../shared/models';

export class ProductsSold {
    product: IdName;
    quantity: number;

    constructor(data: any) {
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/dashboard/shared/models/products-sold.ts